export class AssignmentConstants {
    static GENERAL_TASK_TYPE = "Assignment";
    static GENERAL_TASK_TYPE_WITH_QA = "Assignment w/ QA";
    static FORM_ASSIGNMENT_TASK_TYPE = "Form Assignment";
    static OPEN_STATE = "open";
    static COMPLETED_STATE = "completed";
    static COLLECTION_NAME = "ChannelData";
    static DEFAULT_PRIORITIES = ["High", "Normal", "Low"];
}
